<!-- @format -->

<div class="reports-container">
	<div class="custom-section card">
		<div class="heading">
			<h2 class="title">Report Generation</h2>
			<p class="subtitle">Generate and download reports based on submitted forms. Use the filters below to customise your search and access the data you need.</p>
		</div>

		<div class="dropdown-section-1">
			<!-- Account Holder Dropdown - Super Admin Only -->
			<div class="dropdown-item" *ngIf="currentRole === roles.superAdmin">
				<label class="dropdown-label">Account Holder *</label>
				<app-dropdown
					[disabled]="false"
					[options]="companies"
					selectedItem="{{ selectedValues.company }}"
					(onSelectOption)="retrievePlantsByCompanyId($event)"
					[fields]="['companyId', 'companyName']"
					[label]="
						selectedValues.company.companyName.length === 0
						? 'Select Account holder'
						: selectedValues.company.companyName">
				</app-dropdown>
			</div>

			<!-- Client Dropdown -->
			<div class="dropdown-item">
				<label class="dropdown-label">Client *</label>
				<app-dropdown
					[disabled]="currentRole === roles.admin || (currentRole === roles.superAdmin && selectedValues.company.companyId === 0)"
					[options]="plants"
					selectedItem="{{ selectedValues.plant }}"
					(onSelectOption)="retrieveUnitsByPlantId($event)"
					[fields]="['plantId', 'plantName']"
					[label]="
						resetPlant || selectedValues.plant.plantId == 0
							? 'Select Client'
							: selectedValues.plant.plantName
					"></app-dropdown>
			</div>

			<!-- Branch Dropdown -->
			<div class="dropdown-item">
				<label class="dropdown-label">Branch *</label>
				<app-dropdown
					[disabled]="selectedValues.plant.plantId === 0"
					[options]="units"
					selectedItem="{{ selectedValues.unit }}"
					(onSelectOption)="onUnitSelected($event)"
					[fields]="['unitId', 'unitName']"
					[label]="
						resetUnit || selectedValues.unit.unitId == 0
							? 'Select Branch'
							: selectedValues.unit.unitName
					"></app-dropdown>
			</div>
		</div>


		<div class="dropdown-section-2">

		<!-- Report Name Dropdown -->
			<div class="dropdown-item">
					<label class="dropdown-label">Report Name *</label>
					<app-dropdown
						[disabled]="selectedValues.unit.unitId === 0"
						[options]="reportTypes"
						selectedItem="{{ selectedReport }}"
						(onSelectOption)="onReportSelected($event)"
						[fields]="['reportId', 'reportName']"
						[label]="
							selectedReport.reportId == 0
								? 'Select Report'
								: selectedReport.reportName
						"></app-dropdown>
			</div>

			<!-- Form Name Dropdown -->
			<div class="dropdown-item">
					<label class="dropdown-label">Form Name *</label>
					<app-dropdown
						[disabled]="selectedReport.reportId === 0"
						[options]="forms"
						selectedItem="{{ selectedForm }}"
						(onSelectOption)="onFormSelected($event)"
						[fields]="['logSheetTemplateId', 'logSheetName']"
						[label]="
							selectedForm.logSheetTemplateId == 0
								? 'Select Form'
								: selectedForm.logSheetName
						"></app-dropdown>
				</div>
				
			</div>


	<div class="dropdown-section-3 r-start-end-date">
		<!-- Start Date Input -->
		<div class="dropdown-item">
				<label class="dropdown-label">Start Date *</label>
				<input 
					type="date" 
					class="date-input"
					[(ngModel)]="startDate"
					(change)="onDateChange()"
					[disabled]="selectedForm.logSheetTemplateId === 0"
					placeholder="Select Start Date" />
		</div>

	<!-- End Date Input -->
	<div class="dropdown-item">
			<label class="dropdown-label">End Date *</label>
			<input 
				type="date" 
				class="date-input"
				[ngClass]="{'date-error': dateError}"
				[(ngModel)]="endDate"
				(change)="onDateChange()"
				[disabled]="selectedForm.logSheetTemplateId === 0"
				placeholder="Select End Date" />
			<div class="error-message-container">
				<span class="error-message" *ngIf="dateError">{{ dateError }}</span>
			</div>
		</div>			<!-- Report Format Dropdown -->
			<div class="dropdown-item">
				<label class="dropdown-label">Report Format *</label>
				<app-dropdown
					[disabled]="!startDate || !endDate || !validateDates()"
					[options]="reportFormats"
					 selectedItem="{{ selectedFormat }}"
					(onSelectOption)="onFormatSelected($event)"
					[fields]="['formatId', 'formatName']"
					[label]="
						selectedFormat.formatId == 0
							? 'Select Format'
							: selectedFormat.formatName
					"></app-dropdown>
			</div>
		</div>

	<!-- Generate Report Button -->
	<div class="button-section">
			<button 
				*ngIf="!reportReady"
				type="button"
				class="generate-button"
				[disabled]="!isFormValid() || isGenerating"
				(click)="generateReport()">
				<span *ngIf="!isGenerating">Generate Report</span>
				<span *ngIf="isGenerating" class="loading-content">
					<span class="spinner"></span>
					Generating...
				</span>
			</button>

			<button 
				*ngIf="reportReady"
				type="button"
				class="download-button"
				(click)="downloadReport()">
				Download Report
			</button>
		</div>
	</div>
</div>
